import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiEndpoints } from 'Utils/ApiEndpoints';

const baseUrl = process.env.REACT_APP_BASE_URL
const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth?.authData?.token;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })(args, api, extraOptions);
    if (result?.error && result?.error.status === 400) {
        return " ";
    }
    if (result?.error && result?.error.status === 401) {
        window.location.href = '/'
    }
    return result;
};
export const commonApi = createApi({
    reducerPath: 'commonApi',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['CommonData', 'Faq'],
    endpoints: (builder) => ({
        getCommonData: builder.query({
            query: () => ({
                url: apiEndpoints?.commonContentUrl,
                method: 'GET',
            }),
            providesTags: ['CommonData'],
        }),
        updateCommonData: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.commonContentUpdateUrl,
                method: "PUT",
                body: commonData
            }),
            invalidatesTags: ['CommonData'],
        }),
        updateTipsData: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.commonTipsUpdateUrl,
                method: "PUT",
                body: commonData
            }),
            invalidatesTags: ['CommonData'],
        }),
        updateSubTipsData: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.commonSubTipsUpdateUrl,
                method: "PUT",
                body: commonData
            }),
            invalidatesTags: ['CommonData'],
        }),
        getFaq: builder.query({
            query: () => ({
                url: apiEndpoints?.faqGetUrl,
                method: 'GET',
            }),
            providesTags: ['Faq'],
        }),
        getTips: builder.query({
            query: () => ({
                url: apiEndpoints?.getTipsUrL,
                method: 'GET',
            }),
            providesTags: ['Faq'],
        }),
        addFaq: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.faqCommonUrl,
                method: "POST",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),
        updateFaq: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.faqCommonUrl,
                method: "PUT",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),
        deleteFaq: builder.mutation({
            query: (faqId) => ({
                url: `${apiEndpoints?.faqCommonUrl}`,
                method: 'DELETE',
                body: { question_id: faqId }
            }),
            invalidatesTags: ['Faq'],
        }),
        getSubTips: builder.query({
            query: (_id) => ({
                url: `${apiEndpoints?.getSubTipsUrl}?Id=${_id}`,
                method: 'GET',
            }),
            providesTags: ['User'],
        }),
        getShopItemDetails: builder.query({
            query: (_id) => ({
                url: `${apiEndpoints?.getSubTipsUrl}?Id=${_id}`,
                method: 'GET',
            }),
            providesTags: ['User'],
        }),
        ///health fitness
        addHealthFitness: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.addHealthFitnessUrl,
                method: "POST",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),
        getFitnessItemDetails: builder.query({
            query: (_id) => ({
                url: `${apiEndpoints?.getFitnessItemDetailsUrl}?Id=${_id}`,
                method: 'GET',
            }),
            providesTags: ['User'],
        }),
        getHealthData: builder.query({
             query: ({ page, limit, search, sort_column, sort_direction }) => {
                // Use a params object to cleanly handle optional parameters
                const params = {
                    page,
                    limit,
                };

                // Conditionally add parameters if they exist
                if (search) {
                    params.search = search;
                }
                if (sort_column) {
                    params.sort_column = sort_column;
                }
                if (sort_direction) {
                    params.sort_direction = sort_direction;
                }

                return {
                    url: apiEndpoints?.getHealthDataUrl,
                    method: 'GET',
                    params: params, // RTK Query will automatically convert this to a query string
                };
            },
            providesTags: ['User'],
        }),
        updateHealthStatus: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.updateHealthStatusUrl,
                method: "PUT",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),
        //invest

        addInvest: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.addInvestUrl,
                method: "POST",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),
        getInvestItemDetails: builder.query({
            query: (_id) => ({
                url: `${apiEndpoints?.getInvestItemDetailsUrl}?Id=${_id}`,
                method: 'GET',
            }),
            providesTags: ['User'],
        }),
        getInvestData: builder.query({
             query: ({ page, limit, search, sort_column, sort_direction }) => {
                // Use a params object to cleanly handle optional parameters
                const params = {
                    page,
                    limit,
                };

                // Conditionally add parameters if they exist
                if (search) {
                    params.search = search;
                }
                if (sort_column) {
                    params.sort_column = sort_column;
                }
                if (sort_direction) {
                    params.sort_direction = sort_direction;
                }

                return {
                    url: apiEndpoints?.getInvestDataUrl,
                    method: 'GET',
                    params: params, // RTK Query will automatically convert this to a query string
                };
            },

            providesTags: ['User'],
        }),
        updateInvestStatus: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.updateInvestStatusUrl,
                method: "PUT",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),

        //Ai tips

        addAiTips: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.addAiTipsUrl,
                method: "POST",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),
        getAiTipsItemDetails: builder.query({
            query: (_id) => ({
                url: `${apiEndpoints?.getAiTipsItemDetailsUrl}?Id=${_id}`,
                method: 'GET',
            }),
            providesTags: ['User'],
        }),
        getAiTipsData: builder.query({
             query: ({ page, limit, search, sort_column, sort_direction }) => {
                // Use a params object to cleanly handle optional parameters
                const params = {
                    page,
                    limit,
                };

                // Conditionally add parameters if they exist
                if (search) {
                    params.search = search;
                }
                if (sort_column) {
                    params.sort_column = sort_column;
                }
                if (sort_direction) {
                    params.sort_direction = sort_direction;
                }

                return {
                    url: apiEndpoints?.getAiTipsDataUrl,
                    method: 'GET',
                    params: params, // RTK Query will automatically convert this to a query string
                };
            },
            providesTags: ['User'],
        }),
        updateAiTipsStatus: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.updateAiTipsStatusUrl,
                method: "PUT",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),

        //product
        addProduct: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.addProductUrl,
                method: "POST",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),
        getProductItemDetails: builder.query({
            query: (_id) => ({
                url: `${apiEndpoints?.getProductItemDetailsUrl}?Id=${_id}`,
                method: 'GET',
            }),
            providesTags: ['User'],
        }),
        getProductData: builder.query({

            query: ({ page, limit, search, sort_column, sort_direction }) => {
                // Use a params object to cleanly handle optional parameters
                const params = {
                    page,
                    limit,
                };

                // Conditionally add parameters if they exist
                if (search) {
                    params.search = search;
                }
                if (sort_column) {
                    params.sort_column = sort_column;
                }
                if (sort_direction) {
                    params.sort_direction = sort_direction;
                }

                return {
                    url: apiEndpoints?.getProductDataUrl,
                    method: 'GET',
                    params: params, // RTK Query will automatically convert this to a query string
                };
            },

            providesTags: ['User'],
        }),
        updateProductStatus: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.updateProductStatusUrl,
                method: "PUT",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),

        //meditation
        getMeditationData: builder.query({
             query: ({ page, limit, search, sort_column, sort_direction }) => {
                // Use a params object to cleanly handle optional parameters
                const params = {
                    page,
                    limit,
                };

                // Conditionally add parameters if they exist
                if (search) {
                    params.search = search;
                }
                if (sort_column) {
                    params.sort_column = sort_column;
                }
                if (sort_direction) {
                    params.sort_direction = sort_direction;
                }

                return {
                    url: apiEndpoints?.getMeditationDataUrl,
                    method: 'GET',
                    params: params, // RTK Query will automatically convert this to a query string
                };
            },

            providesTags: ['User'],
        }),

        addMeditation: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.addMeditationUrl,
                method: "POST",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),

        updateMeditationStatus: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.updateMeditationStatusUrl,
                method: "PUT",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),
        getMeditationDetails: builder.query({
            query: (_id) => ({
                url: `${apiEndpoints?.getMeditationDetailsUrl}?Id=${_id}`,
                method: 'GET',
            }),
            providesTags: ['User'],
        }),

        ///
        getMeditationItemsData: builder.query({
           
             query: ({ page, limit, search, sort_column, sort_direction ,category}) => {
                // Use a params object to cleanly handle optional parameters
                const params = {
                    page,
                    limit,
                };

                // Conditionally add parameters if they exist
                if (search) {
                    params.search = search;
                }
                if (sort_column) {
                    params.sort_column = sort_column;
                }
                if (sort_direction) {
                    params.sort_direction = sort_direction;
                }

                return {
                    url: apiEndpoints?.getMeditationItemsUrl+`?category=${category}`,
                    method: 'GET',
                    params: params, // RTK Query will automatically convert this to a query string
                };
            },

            providesTags: ['User'],
        }),
        addMeditationItems: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.addMeditationItemsUrl,
                method: "POST",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),
        getMeditationItemDetails: builder.query({
            query: (_id) => ({
                url: `${apiEndpoints?.getMeditationItemDetailsUrl}?Id=${_id}`,
                method: 'GET',
            }),
            providesTags: ['User'],
        }),
        updateMeditationItemsStatus: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.updateMeditationItemsStatusUrl,
                method: "PUT",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),
    })
});

export const {
    useGetCommonDataQuery,
    useGetTipsQuery,
    useUpdateCommonDataMutation,
    useUpdateTipsDataMutation,
    useGetFaqQuery,
    useUpdateFaqMutation,
    useAddFaqMutation,
    useDeleteFaqMutation,
    useGetSubTipsQuery,
    useUpdateSubTipsDataMutation,
    useGetShopItemDetailsQuery,

    //health
    useAddHealthFitnessMutation,
    useGetHealthDataQuery,
    useUpdateHealthStatusMutation,
    useGetFitnessItemDetailsQuery,

    //invest
    useAddInvestMutation,
    useGetInvestDataQuery,
    useUpdateInvestStatusMutation,
    useGetInvestItemDetailsQuery,

    //ai tips
    useAddAiTipsMutation,
    useGetAiTipsDataQuery,
    useUpdateAiTipsStatusMutation,
    useGetAiTipsItemDetailsQuery,

    //production

    useAddProductMutation,
    useGetProductDataQuery,
    useUpdateProductStatusMutation,
    useGetProductItemDetailsQuery,

    //meditation
    useGetMeditationDataQuery,
    useAddMeditationMutation,
    useUpdateMeditationStatusMutation,
    useGetMeditationDetailsQuery,
    ///meditation items
    useGetMeditationItemsDataQuery,
    useAddMeditationItemsMutation,
    useGetMeditationItemDetailsQuery,
    useUpdateMeditationItemsStatusMutation,
} = commonApi;
